import { render, staticRenderFns } from "./PostFileItem.vue?vue&type=template&id=215cb956&scoped=true&"
import script from "./PostFileItem.vue?vue&type=script&lang=ts&"
export * from "./PostFileItem.vue?vue&type=script&lang=ts&"
import style0 from "./PostFileItem.vue?vue&type=style&index=0&id=215cb956&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215cb956",
  null
  
)

export default component.exports